import { forwardRef, type Ref, type SVGProps } from "react";
const IconTextItalicsFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M24 6V2H12v4h3.26l-4.62 20H6v4h12v-4h-3.26l4.62-20z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconTextItalicsFilledSVG);
ForwardRef.displayName = "IconTextItalicsFilled";
export { ForwardRef as IconTextItalicsFilled };
